// Education Reducer

const educationReducerDefaultState = {
    educationList:{}
};

export default (state = educationReducerDefaultState, action) => {

    switch (action.type) {
       
        case 'LIST_EDUCATION':
            return {
                ...state,
                educationList: action.education
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/education.js